import { useCallback, useState } from "react";

const LS_KEY = "linecontrol_order_pages_auto_refresh";

function readInitialAutoRefresh() {
  try {
    const v = localStorage.getItem(LS_KEY);
    if (v === null) {
      return true;
    }
    return v === "1" || v === "true";
  } catch {
    return true;
  }
}

/** Shared auto-refresh toggle for /order_list and /chart (persisted in localStorage). */
export function useSyncedOrderPagesAutoRefresh() {
  const [autoRefresh, setAutoRefresh] = useState(readInitialAutoRefresh);

  const setAutoRefreshSynced = useCallback((next) => {
    setAutoRefresh((prev) => {
      const resolved = typeof next === "function" ? next(prev) : next;
      try {
        localStorage.setItem(LS_KEY, resolved ? "1" : "0");
      } catch {
        /* ignore quota / private mode */
      }
      return resolved;
    });
  }, []);

  return [autoRefresh, setAutoRefreshSynced];
}
